import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';

var _a;
var TRANSACTIONS_NAMESPACE = 'TRANSACTIONS_NAMESPACE';
// Payments
var CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
var SET_TRANSACTIONS = 'SET_TRANSACTIONS';
var SET_IS_LOADING_STATE = 'SET_IS_LOADING_STATE';
var APPEND_TRANSACTIONS = 'APPEND_TRANSACTIONS';
// Bonuses
var SET_BONUSES_TRANSACTIONS = 'SET_BONUSES_TRANSACTIONS';
// Sportsbook
var SET_SPORTS_TRANSACTIONS = 'SET_SPORTS_TRANSACTIONS';
var APPEND_SPORTS_TRANSACTIONS = 'APPEND_SPORTS_TRANSACTIONS';
var CLEAR_SPORTS_TRANSACTIONS = 'CLEAR_SPORTS_TRANSACTIONS';
var transactionsGetters = {
    getTransactions: function (state) {
        return state.transactions;
    },
    getTransactionsTotal: function (state) {
        return state.total;
    },
    isLoadingState: function (state) {
        return state.isLoading;
    },
    getBonusesTransactions: function (state) {
        return state.bonusesTransactions;
    },
    getSportsTransactions: function (state) {
        return state.sportsTransactions;
    },
    getSportsTransactionsTotal: function (state) {
        return state.sportsTotal;
    },
    getDisplaySize: function (state) {
        return state.displaySize;
    },
};
var transactionsActions = {
    fetchTransactions: function (_a, _b) {
        var commit = _a.commit;
        var from = _b.from, to = _b.to, size = _b.size, starting = _b.starting, mediatorType = _b.mediatorType, typeFilter = _b.typeFilter, _c = _b.loadMore, loadMore = _c === void 0 ? false : _c, _d = _b.displaySize, displaySize = _d === void 0 ? 0 : _d;
        return __awaiter(this, void 0, void 0, function () {
            var mutationType, params, transactions_1, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit(SET_IS_LOADING_STATE, true);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        mutationType = loadMore
                            ? APPEND_TRANSACTIONS
                            : SET_TRANSACTIONS;
                        if (mutationType === SET_TRANSACTIONS) {
                            commit(CLEAR_TRANSACTIONS);
                            commit(CLEAR_SPORTS_TRANSACTIONS);
                        }
                        params = {
                            size: size,
                            from: starting,
                            dateFrom: from.toISOString(),
                            dateTo: to.toISOString(),
                            mediatorType: mediatorType,
                            operationType: typeFilter,
                        };
                        return [4 /*yield*/, magic.methods.users.getUserTransactionsHistory(params)];
                    case 2:
                        transactions_1 = _e.sent();
                        commit(mutationType, {
                            transactions: transactions_1,
                            size: size,
                            starting: starting,
                            displaySize: displaySize,
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _e.sent();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        commit(SET_IS_LOADING_STATE, false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    fetchSportsTransactions: function (_a, _b) {
        var commit = _a.commit;
        var from = _b.from, to = _b.to, size = _b.size, starting = _b.starting, typeFilter = _b.typeFilter, _c = _b.loadMore, loadMore = _c === void 0 ? false : _c, _d = _b.displaySize, displaySize = _d === void 0 ? 0 : _d;
        return __awaiter(this, void 0, void 0, function () {
            var mutationType, params, sportsTransactions, e_2;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        commit(SET_IS_LOADING_STATE, true);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        mutationType = loadMore
                            ? APPEND_SPORTS_TRANSACTIONS
                            : SET_SPORTS_TRANSACTIONS;
                        if (mutationType === SET_SPORTS_TRANSACTIONS) {
                            commit(CLEAR_SPORTS_TRANSACTIONS);
                        }
                        params = {
                            size: size,
                            from: starting,
                            dateFrom: from.toISOString(),
                            dateTo: to.toISOString(),
                            mediatorType: CoreXMediatorType.SPORTS,
                            operationType: typeFilter,
                        };
                        return [4 /*yield*/, magic.methods.users.getUserTransactionsHistory(params)];
                    case 2:
                        sportsTransactions = _e.sent();
                        commit(mutationType, {
                            transactions: sportsTransactions,
                            displaySize: displaySize,
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _e.sent();
                        console.error(e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        commit(SET_IS_LOADING_STATE, false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    fetchBonusesTransactions: function (_a, _b) {
        var commit = _a.commit;
        var filter = _b.filter, limit = _b.limit, page = _b.page;
        return __awaiter(this, void 0, void 0, function () {
            var params, transactions_2, e_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit(SET_IS_LOADING_STATE, true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        params = {
                            filter: filter !== null && filter !== void 0 ? filter : '',
                            limit: limit,
                            page: page,
                        };
                        return [4 /*yield*/, magic.methods.users.getUserBonusesTransactionsHistory(params)];
                    case 2:
                        transactions_2 = _c.sent();
                        commit(SET_BONUSES_TRANSACTIONS, {
                            transactions: transactions_2,
                            limit: limit,
                            page: page,
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_3 = _c.sent();
                        console.error(e_3);
                        return [3 /*break*/, 5];
                    case 4:
                        commit(SET_IS_LOADING_STATE, false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
};
var transactions = {
    namespaced: true,
    state: {
        transactions: [],
        sportsTransactions: [],
        bonusesTransactions: [],
        from: 0,
        size: 5,
        displaySize: 0,
        total: 0,
        sportsTotal: 0,
        isLoading: true,
    },
    getters: transactionsGetters,
    actions: transactionsActions,
    mutations: (_a = {},
        _a[CLEAR_TRANSACTIONS] = function (state) {
            state.transactions = [];
            state.total = 0;
        },
        _a[CLEAR_SPORTS_TRANSACTIONS] = function (state) {
            state.sportsTransactions = [];
            state.sportsTotal = 0;
        },
        _a[SET_TRANSACTIONS] = function (state, payload) {
            var _a;
            if (!payload.transactions) {
                state.transactions = [];
                state.total = 0;
            }
            else {
                state.transactions =
                    (_a = payload.transactions.ActivityUserWalletTransactions) !== null && _a !== void 0 ? _a : [];
                state.total = payload.transactions.Total;
            }
            state.size = payload.size;
            state.from = payload.starting;
            state.displaySize = payload.displaySize;
        },
        _a[APPEND_TRANSACTIONS] = function (state, payload) {
            var _a;
            if ((_a = payload.transactions) === null || _a === void 0 ? void 0 : _a.ActivityUserWalletTransactions) {
                // Ensure `state.transactions` is initialized as an array (tslib version limitation)
                state.transactions = (state.transactions || []).concat(payload.transactions.ActivityUserWalletTransactions);
            }
            state.total = payload.transactions.Total;
            state.displaySize = payload.displaySize;
        },
        _a[SET_IS_LOADING_STATE] = function (state, payload) {
            state.isLoading = payload;
        },
        _a[SET_BONUSES_TRANSACTIONS] = function (state, payload) {
            state.bonusesTransactions = Array.isArray(payload.transactions)
                ? payload.transactions
                : [payload.transactions];
        },
        _a[SET_SPORTS_TRANSACTIONS] = function (state, payload) {
            var _a;
            if (!payload.transactions) {
                state.sportsTransactions = [];
            }
            else {
                state.sportsTransactions =
                    (_a = payload.transactions.ActivityUserWalletTransactions) !== null && _a !== void 0 ? _a : [];
                state.sportsTotal = payload.transactions.Total;
            }
            state.displaySize = payload.displaySize;
        },
        _a[APPEND_SPORTS_TRANSACTIONS] = function (state, payload) {
            var _a;
            if ((_a = payload.transactions) === null || _a === void 0 ? void 0 : _a.ActivityUserWalletTransactions) {
                // Ensure `state.transactions` is initialized as an array (tslib version limitation)
                state.sportsTransactions = (state.sportsTransactions || []).concat(payload.transactions.ActivityUserWalletTransactions);
            }
            state.sportsTotal = payload.transactions.Total;
            state.displaySize = payload.displaySize;
        },
        _a),
};

export { APPEND_SPORTS_TRANSACTIONS, APPEND_TRANSACTIONS, CLEAR_SPORTS_TRANSACTIONS, CLEAR_TRANSACTIONS, SET_BONUSES_TRANSACTIONS, SET_IS_LOADING_STATE, SET_SPORTS_TRANSACTIONS, SET_TRANSACTIONS, TRANSACTIONS_NAMESPACE, transactions, transactionsActions, transactionsGetters };
